"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/style.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Fstyle.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.textStyleModifierToJSON = exports.textStyleModifierFromJSON = exports.gradientToJSON = exports.gradientFromJSON = exports.colorToJSON = exports.colorFromJSON = exports.ColorHex = exports.IconStyle = exports.BorderStyle = exports.TextStyle = exports.TextStyleModifier = exports.Gradient = exports.Color = void 0;
const protobufPackage = 'com.step.render.proto';
/**
 * Well-known colors.
 *
 * Subset of colors defined in:
 * https://github.com/getstep/client/blob/master/src/theme/Colors.ts
 */
var Color;
(function (Color) {
    Color["INVALID_COLOR"] = "INVALID_COLOR";
    Color["PRIMARY_COLOR"] = "PRIMARY_COLOR";
    Color["TEXT_COLOR"] = "TEXT_COLOR";
    Color["SECONDARY_TEXT_COLOR"] = "SECONDARY_TEXT_COLOR";
    Color["POSITIVE_TEXT_COLOR"] = "POSITIVE_TEXT_COLOR";
    Color["NEGATIVE_TEXT_COLOR"] = "NEGATIVE_TEXT_COLOR";
    Color["WARNING_TEXT_COLOR"] = "WARNING_TEXT_COLOR";
    Color["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Color || (exports.Color = Color = {}));
/**
 * Well-known gradients.
 */
var Gradient;
(function (Gradient) {
    Gradient["INVALID_GRADIENT"] = "INVALID_GRADIENT";
    Gradient["RAINBOW_SHERBET_GRADIENT"] = "RAINBOW_SHERBET_GRADIENT";
    Gradient["MIDNIGHT_GRADIENT"] = "MIDNIGHT_GRADIENT";
    Gradient["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Gradient || (exports.Gradient = Gradient = {}));
var TextStyleModifier;
(function (TextStyleModifier) {
    TextStyleModifier["INVALID_TEXT_STYLE_MODIFIER"] = "INVALID_TEXT_STYLE_MODIFIER";
    TextStyleModifier["BOLD"] = "BOLD";
    TextStyleModifier["STRIKETHROUGH"] = "STRIKETHROUGH";
    /**
     * PILL - Display the text inside a "text pill" (a rounded rectangle).
     */
    TextStyleModifier["PILL"] = "PILL";
    TextStyleModifier["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TextStyleModifier || (exports.TextStyleModifier = TextStyleModifier = {}));
function createBaseTextStyle() {
    return { color: undefined, gradient: undefined, strikethrough: false, modifiers: [] };
}
exports.TextStyle = {
    fromJSON(object) {
        const message = {
            modifiers: globalThis.Array.isArray(object?.modifiers)
                ? object.modifiers.map((e) => textStyleModifierFromJSON(e))
                : [],
        };
        if (isSet(object.color)) {
            message.color = colorFromJSON(object.color);
        }
        if (isSet(object.gradient)) {
            message.gradient = gradientFromJSON(object.gradient);
        }
        if (isSet(object.strikethrough)) {
            message.strikethrough = globalThis.Boolean(object.strikethrough);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.color !== undefined) {
            obj.color = colorToJSON(message.color);
        }
        if (message.gradient !== undefined) {
            obj.gradient = gradientToJSON(message.gradient);
        }
        if (message.strikethrough !== undefined && message.strikethrough !== false) {
            obj.strikethrough = message.strikethrough;
        }
        if (message.modifiers?.length) {
            obj.modifiers = message.modifiers.map((e) => textStyleModifierToJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.TextStyle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTextStyle();
        message.color = object.color ?? undefined;
        message.gradient = object.gradient ?? undefined;
        message.strikethrough = object.strikethrough ?? false;
        message.modifiers = object.modifiers?.map((e) => e) || [];
        return message;
    },
};
function createBaseBorderStyle() {
    return { color: undefined, gradient: undefined };
}
exports.BorderStyle = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.color)) {
            message.color = colorFromJSON(object.color);
        }
        if (isSet(object.gradient)) {
            message.gradient = gradientFromJSON(object.gradient);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.color !== undefined) {
            obj.color = colorToJSON(message.color);
        }
        if (message.gradient !== undefined) {
            obj.gradient = gradientToJSON(message.gradient);
        }
        return obj;
    },
    create(base) {
        return exports.BorderStyle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBorderStyle();
        message.color = object.color ?? undefined;
        message.gradient = object.gradient ?? undefined;
        return message;
    },
};
function createBaseIconStyle() {
    return { color: undefined, gradient: undefined, colorHex: undefined };
}
exports.IconStyle = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.color)) {
            message.color = colorFromJSON(object.color);
        }
        if (isSet(object.gradient)) {
            message.gradient = gradientFromJSON(object.gradient);
        }
        if (isSet(object.colorHex)) {
            message.colorHex = exports.ColorHex.fromJSON(object.colorHex);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.color !== undefined) {
            obj.color = colorToJSON(message.color);
        }
        if (message.gradient !== undefined) {
            obj.gradient = gradientToJSON(message.gradient);
        }
        if (message.colorHex !== undefined) {
            obj.colorHex = exports.ColorHex.toJSON(message.colorHex);
        }
        return obj;
    },
    create(base) {
        return exports.IconStyle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIconStyle();
        message.color = object.color ?? undefined;
        message.gradient = object.gradient ?? undefined;
        message.colorHex = (object.colorHex !== undefined && object.colorHex !== null)
            ? exports.ColorHex.fromPartial(object.colorHex)
            : undefined;
        return message;
    },
};
function createBaseColorHex() {
    return { hex: '' };
}
exports.ColorHex = {
    fromJSON(object) {
        const message = { hex: isSet(object.hex) ? globalThis.String(object.hex) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hex !== '') {
            obj.hex = message.hex;
        }
        return obj;
    },
    create(base) {
        return exports.ColorHex.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseColorHex();
        message.hex = object.hex ?? '';
        return message;
    },
};
function colorFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_COLOR':
            return Color.INVALID_COLOR;
        case 1:
        case 'PRIMARY_COLOR':
            return Color.PRIMARY_COLOR;
        case 2:
        case 'TEXT_COLOR':
            return Color.TEXT_COLOR;
        case 3:
        case 'SECONDARY_TEXT_COLOR':
            return Color.SECONDARY_TEXT_COLOR;
        case 4:
        case 'POSITIVE_TEXT_COLOR':
            return Color.POSITIVE_TEXT_COLOR;
        case 5:
        case 'NEGATIVE_TEXT_COLOR':
            return Color.NEGATIVE_TEXT_COLOR;
        case 6:
        case 'WARNING_TEXT_COLOR':
            return Color.WARNING_TEXT_COLOR;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Color.UNRECOGNIZED;
    }
}
exports.colorFromJSON = colorFromJSON;
function colorToJSON(object) {
    switch (object) {
        case Color.INVALID_COLOR:
            return 'INVALID_COLOR';
        case Color.PRIMARY_COLOR:
            return 'PRIMARY_COLOR';
        case Color.TEXT_COLOR:
            return 'TEXT_COLOR';
        case Color.SECONDARY_TEXT_COLOR:
            return 'SECONDARY_TEXT_COLOR';
        case Color.POSITIVE_TEXT_COLOR:
            return 'POSITIVE_TEXT_COLOR';
        case Color.NEGATIVE_TEXT_COLOR:
            return 'NEGATIVE_TEXT_COLOR';
        case Color.WARNING_TEXT_COLOR:
            return 'WARNING_TEXT_COLOR';
        case Color.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.colorToJSON = colorToJSON;
function gradientFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_GRADIENT':
            return Gradient.INVALID_GRADIENT;
        case 1:
        case 'RAINBOW_SHERBET_GRADIENT':
            return Gradient.RAINBOW_SHERBET_GRADIENT;
        case 2:
        case 'MIDNIGHT_GRADIENT':
            return Gradient.MIDNIGHT_GRADIENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Gradient.UNRECOGNIZED;
    }
}
exports.gradientFromJSON = gradientFromJSON;
function gradientToJSON(object) {
    switch (object) {
        case Gradient.INVALID_GRADIENT:
            return 'INVALID_GRADIENT';
        case Gradient.RAINBOW_SHERBET_GRADIENT:
            return 'RAINBOW_SHERBET_GRADIENT';
        case Gradient.MIDNIGHT_GRADIENT:
            return 'MIDNIGHT_GRADIENT';
        case Gradient.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.gradientToJSON = gradientToJSON;
function textStyleModifierFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TEXT_STYLE_MODIFIER':
            return TextStyleModifier.INVALID_TEXT_STYLE_MODIFIER;
        case 1:
        case 'BOLD':
            return TextStyleModifier.BOLD;
        case 2:
        case 'STRIKETHROUGH':
            return TextStyleModifier.STRIKETHROUGH;
        case 3:
        case 'PILL':
            return TextStyleModifier.PILL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TextStyleModifier.UNRECOGNIZED;
    }
}
exports.textStyleModifierFromJSON = textStyleModifierFromJSON;
function textStyleModifierToJSON(object) {
    switch (object) {
        case TextStyleModifier.INVALID_TEXT_STYLE_MODIFIER:
            return 'INVALID_TEXT_STYLE_MODIFIER';
        case TextStyleModifier.BOLD:
            return 'BOLD';
        case TextStyleModifier.STRIKETHROUGH:
            return 'STRIKETHROUGH';
        case TextStyleModifier.PILL:
            return 'PILL';
        case TextStyleModifier.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.textStyleModifierToJSON = textStyleModifierToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=style.js.map